import { useQuery } from '@tanstack/react-query';

import { Services } from '@/infra/services';
import { type ProductContext } from '@/infra/services/new-tail/model';
import { useUserResources } from '@/presenters/hooks/user';
import { useGlobalStore } from '@/presenters/store/global';

interface UseProductsAdsProps {
  context: ProductContext;
  id: string;
}

const useProductsAds = (props: Readonly<UseProductsAdsProps>) => {
  const { context, id } = props;

  const {
    server: { isOnMobileApp, device: serverDevice },
  } = useGlobalStore((state) => state);

  const { data: userTrackingId } = useUserResources((data) => data.trackingId);
  const { data: userId } = useUserResources((data) => data.id);

  const device = isOnMobileApp ? 'app' : serverDevice;

  const query = useQuery(
    ['products-ads', userTrackingId, context, id, device],
    async () => {
      if (!userTrackingId) return;

      return Services.NewTail.getProductsAds({
        context,
        sessionId: userTrackingId,
        userId,
        device,
      });
    },
    {
      enabled: Boolean(userTrackingId),
    }
  );

  return query;
};

export default useProductsAds;
